import React from 'react';
import { Heading } from '@zillow/constellation-10';

const UnsubscribeError = () => {
  return (
    <>
      <Heading level={1} textStyle="heading-lg" fontFamily="heading-alt" css={{ marginTop: '800' }}>
        We&apos;re sorry!
      </Heading>
      <Heading level={2} textStyle="body-lg-bold" css={{ marginTop: '600' }}>
        An unexpected error occurred while trying to update your email preferences. We will work to fix this
        expeditiously
      </Heading>
    </>
  );
};

export default UnsubscribeError;
